import React, { useEffect } from 'react';

const items = [
  {
    id: 'learning_journey',
    icon: '🗺️',
    title: '學習旅程',
    desc: '跟隨引導路徑掌握語言技能'
  },
  {
    id: 'game_mode_courses',
    icon: '🎮',
    title: '透過遊戲模式建立課程',
    desc: '將學習變成有趣的遊戲'
  },
  {
    id: 'voice_selector',
    icon: '🗣️',
    title: '選擇正確的語氣由你來確定',
    desc: '你自己選擇的合適學習口音'
  },
  {
    id: 'bilingual_tutor_system',
    icon: '👩‍🏫',
    title: '雙語導師的制度',
    desc: '與母語容易得學習英文'
  },
  {
    id: 'voice_quality_tester',
    icon: '🎚️',
    title: '語音品質測試器',
    desc: '測試和優化語音品質'
  },
  {
    id: 'voice_settings',
    icon: '⚙️',
    title: '語音設定',
    desc: '個人化語音偏好設定'
  },
  {
    id: 'grammar_topics',
    icon: '📘',
    title: '語法主題',
    desc: '掌握90個核心語法結構'
  },
  {
    id: 'practical_communication',
    icon: '💬',
    title: '實際上的溝通和細節回饋',
    desc: '以實際上的溝通為主'
  },
  {
    id: 'daily_challenges',
    icon: '🏆',
    title: '每日挑戰與連擊系統',
    desc: '保持學習動力與習慣'
  },
  {
    id: 'ar_practice',
    icon: '🕶️',
    title: 'AR 實境口語練習',
    desc: '沉浸式學習體驗'
  },
  {
    id: 'community_learning',
    icon: '👥',
    title: '社群學習平台',
    desc: '與全球學習者互動'
  },
  {
    id: 'personalized_learning',
    icon: '🧭',
    title: '個人化的學習路徑',
    desc: '專為你設計適合的學習計劃'
  }
];

const SidebarNav = ({ isOpen, onClose, onSelect }) => {
  // Handle focus management when sidebar closes
  useEffect(() => {
    if (!isOpen) {
      // Remove focus from any element inside the sidebar when it closes
      const sidebar = document.querySelector('aside[aria-hidden="true"]');
      if (sidebar) {
        const focusedElement = sidebar.querySelector(':focus');
        if (focusedElement) {
          focusedElement.blur();
        }
      }
    }
  }, [isOpen]);

  return (
    <div className={`fixed inset-0 z-50 ${isOpen ? '' : 'pointer-events-none'}`}>
      {/* backdrop */}
      <div
        className={`absolute inset-0 bg-black/60 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      {/* panel */}
      <aside
        className={`absolute left-0 top-0 h-full w-80 sm:w-96 max-w-[85vw] bg-gray-900 border-r border-white/10 shadow-2xl transform transition-transform duration-300 flex flex-col ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}
        aria-hidden={!isOpen}
        tabIndex={isOpen ? 0 : -1}
      >
        {/* Header - fixed */}
        <div className="flex-shrink-0 p-4 flex items-center justify-between border-b border-white/10 bg-gray-900">
          <div className="text-white font-semibold text-lg">功能導覽</div>
          <button 
            onClick={onClose} 
            className="text-gray-300 hover:text-white transition-colors p-2 hover:bg-white/10 rounded-lg"
            aria-label="Close menu"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Scrollable content */}
        <nav className="flex-1 overflow-y-auto p-3 space-y-3 pb-6">
          {items.map((it) => (
            <button
              key={it.id}
              onClick={() => {
                onSelect?.(it.id);
                onClose?.();
              }}
              tabIndex={isOpen ? 0 : -1}
              className="w-full text-left p-3 rounded-lg bg-gray-800 hover:bg-gray-700 active:bg-gray-600 transition-all duration-200 ease-out hover:translate-x-1 hover:shadow-lg border border-white/10"
            >
              <div className="flex items-start space-x-3">
                <div className="text-2xl flex-shrink-0">{it.icon}</div>
                <div className="flex-1 min-w-0">
                  <div className="text-white font-medium text-sm leading-snug">{it.title}</div>
                  <div className="text-gray-300 text-xs mt-1 leading-relaxed">{it.desc}</div>
                </div>
              </div>
            </button>
          ))}
        </nav>
      </aside>
    </div>
  );
};

export default SidebarNav;


